import { PublicClientApplication } from '@azure/msal-browser'
import type { Configuration, RedirectRequest } from '@azure/msal-browser'

// Public Entra identifiers, baked into the build at build time. Neither is
// a secret: the client id and tenant id are visible in every access token
// and in the browser's network tab regardless.
const clientId = import.meta.env.VITE_CLIENT_ID
const tenantId = import.meta.env.VITE_TENANT_ID

if (!clientId || !tenantId) {
  // Fails loudly at load time rather than silently sending malformed auth
  // requests to Entra — a missing build-time env var should never reach a
  // signed-in-looking screen.
  throw new Error(
    'VITE_CLIENT_ID and VITE_TENANT_ID must be set at build time (see docker/admin-panel/frontend).',
  )
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  cache: {
    // sessionStorage (not localStorage): the admin panel is a
    // privileged surface, tabs should not silently inherit a signed-in
    // session from a tab the operator already closed.
    cacheLocation: 'sessionStorage',
  },
}

/** The single scope this SPA ever asks for: the backend's own exposed API. */
export const loginRequest: RedirectRequest = {
  scopes: [`api://${clientId}/access`],
}

export const msalInstance = new PublicClientApplication(msalConfig)
